<template>
  <v-row>
    <v-col cols="6">
      <v-text-field
        v-model="data.business_name"
        label="Business Name"
        :readonly="listingFieldsReadonly"
      ></v-text-field>
    </v-col>

    <v-col cols="6">
      <v-text-field
        v-model="data.email"
        label="Email"
        :readonly="listingFieldsReadonly"
      ></v-text-field>
    </v-col>

    <v-col cols="6">
      <v-text-field
        v-model="data.website"
        label="Website"
        :readonly="listingFieldsReadonly"
      ></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field
        v-model="data.address"
        label="Address"
        :readonly="listingFieldsReadonly"
      ></v-text-field>
    </v-col>

    <v-col cols="6">
      <v-text-field
        v-model="data.telephone"
        label="Phone"
        :readonly="listingFieldsReadonly"
      ></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field
        v-model="data.mobile"
        label="Mobile"
        :readonly="listingFieldsReadonly"
      ></v-text-field>
    </v-col>

    <v-col cols="6" v-if="!listingFieldsReadonly">
      <select-categories v-model="data.category"></select-categories>
    </v-col>
    <v-col cols="6" v-else>
      <v-text-field v-model="data.category" label="Category" readonly></v-text-field>
    </v-col>
    <v-col cols="6" v-if="!listingFieldsReadonly">
      <select-suburbs v-model="data.suburb"></select-suburbs>
    </v-col>
    <v-col cols="6" v-else>
      <v-text-field v-model="data.suburb" label="Suburb" readonly></v-text-field>
    </v-col>

    <v-col cols="6">
      <date-picker label="Start Date" v-model="data.start_date"></date-picker>
    </v-col>
    <v-col cols="6">
      <date-picker label="End Date" v-model="data.end_date"></date-picker>
    </v-col>

    <v-col cols="6">
      <v-switch v-model="data.active" label="Active"></v-switch>
    </v-col>
    <v-col cols="6">
      <v-switch v-model="data.verified" label="Verified"></v-switch>
    </v-col>

    <v-col cols="12">
      <text-editor v-model="data.about"></text-editor>
    </v-col>

    <v-col cols="12">
      <text-editor v-model="data.services"></text-editor>
    </v-col>

    <v-col cols="12">
      <v-file-input
        v-model="data.image"
        label="Upload Image"
        accept="image/*"
      ></v-file-input>
    </v-col>
  </v-row>
</template>

<script>
import SelectCategories from '../../../components/SelectCategories'
import SelectSuburbs from '../../../components/SelectSuburbs'
import DatePicker from '../../../components/DatePicker'
import TextEditor from '../../../components/TextEditor'

export default {
  name: 'BoldListingForm',
  props: {
    data: {
      type: Object,
      required: true
    },
    listingFieldsReadonly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DatePicker,
    SelectCategories,
    SelectSuburbs,
    TextEditor
  }
}
</script>

<style scoped></style>
